import * as url from "../../constants/urls";

export const getAllBlogs = () => {
  return (dispatch, getState) => {
    //  get blogs data
    return fetch(url.getAllBlogsUrl, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = window.document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const getAllEvents = () => {
  return (dispatch, getState) => {
    //  get blogs data
    return fetch(url.getEventsUrl, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getBlog = (id) => {
  return (dispatch, getState) => {
    //  get blogs data
    return fetch(url.getBlogUrl + id, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};
export const getFetauredBlog = () => {
  return (dispatch, getState) => {
    //  get blogs data
    return fetch(url.featuredBlogUrl, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getRecentPosts = () => {
  return (dispatch, getState) => {
    //  get blogs data
    return fetch(url.recentPostsUrl, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getAds = () => {
  return (dispatch, getState) => {
    const { token } = getState().user.user;
    return fetch(url.getAdsUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const submitQuery = (data) => {
  let form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    return fetch(url.submitQueryUrl, {
      method: "POST",
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getCategories = () => {
  return (dispatch, getState) => {
    return fetch(url.categoriesUrl, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getCountries = () => {
  return (dispatch, getState) => {
    return fetch(url.countriesUrl, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getStates = (id) => {
  return (dispatch, getState) => {
    return fetch(url.statesUrl + id, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};
export const getCities = (id) => {
  return (dispatch, getState) => {
    return fetch(url.citiesUrl + id, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getBankDetails = (code) => {
  return (dispatch, getState) => {
    return fetch(url.ifscUrl + code, {
      method: "GET",
    })
      .then((res) => {
        if (res.status === 200) return res.json();
        else throw new Error("Invalid IFSC code");
      })
      .then((json) => {
        return { bankname: json.BANK, branch_name: json.BRANCH };
      });
  };
};

export const getDropdown = () => {
  return (dispatch, getState) => {
    return fetch(url.getContactDropUrl, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.dropdown;
        } else {
          throw Error(json.message);
        }
      });
  };
};
export const VisitingUser = (data) => {
  let form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    return fetch(url.UTMClick, {
      method: "POST",
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          return Error(json.message);
        }
      });
  };
};
export const getEmotionalEatingResponseData = () => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getEmotionalEatingResponseDataUrl, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          throw new Error(json.message);
        }
      });
  };
};

export const postEmotionalEatingResponseData = (formData) => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getEmotionalEatingResponseDataUrl , {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getStressMgmtResponseData = () => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getStressMgmtResponseDataUrl, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          throw new Error(json.message);
        }
      });
  };
};

export const postStressMgmtResponseData = (formData) => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getStressMgmtResponseDataUrl, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const getNetworkingResponseData = () => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getNetworkingResponseDataUrl, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          throw new Error(json.message);
        }
      });
  };
};

export const postNetworkingResponseData = (formData) => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getNetworkingResponseDataUrl, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json);
        }
      })
      .catch((err) => console.log(err));
  };
};
export const getNurturingResponseData = () => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getNurturingResponseDataUrl, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          throw new Error(json.message);
        }
      });
  };
};

export const postNurturingResponseData = (formData) => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getNurturingResponseDataUrl, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        console.log(json);
        if (json.success) {
          return json.data;
        } else {
          throw Error(json);
        }
      })
      .catch((err) => console.log(err));
  };
};


export const getBurnoutResponseData = () => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getBurnoutResponseDataUrl, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          throw new Error(json.message);
        }
      });
  };
};

export const postBurnoutResponseData = (formData) => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getBurnoutResponseDataUrl, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        console.log(json);
        if (json.success) {
          return json.data;
        } else {
          throw Error(json);
        }
      })
      .catch((err) => console.log(err));
  };
};

export const getBodyShamingResponseData = () => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getBodyShamingResponseDataUrl, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          throw new Error(json.message);
        }
      });
  };
};

export const postBodyShamingResponseData = (formData) => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getBodyShamingResponseDataUrl, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};


export const getIkigaiResponseData = () => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getIkigaiResponseDataUrl, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          throw new Error(json.message);
        }
      });
  };
};

export const postIkigaiResponseData = (formData) => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getIkigaiResponseDataUrl, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          throw Error(json.message);
        }
      });
  };
};



export const getHeartbreakResponseData = () => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getHeartbreakResponseDataUrl, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          throw new Error(json.message);
        }
      });
  };
};

export const postHeartbreakResponseData = (formData) => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getHeartbreakResponseDataUrl, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          console.log(json)
          throw Error(json.message);
        }
      });
  };
};

export const getFaliureResponseData = () => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getFaliureResponseDataUrl, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          throw new Error(json.message);
        }
      });
  };
};

export const postFaliureResponseData = (formData) => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getFaliureResponseDataUrl, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          console.log(json)
          throw Error(json.message);
        }
      });
  };
};

export const getLeadershipResponseData = () => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getLeadershipResponseDataUrl, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          throw new Error(json.message);
        }
      });
  };
};

export const postLeadershipResponseData = (formData) => {
  return (dispatch, getState) => {
    const token = getCookie("token");
    return fetch(url.getLeadershipResponseDataUrl, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          console.log(json)
          throw Error(json.message);
        }
      });
  };
};
